module.exports = InternalShared('InternalShared/Events/GetControl');